import { ChangeDetectorRef, Component, OnInit, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { CatReportesService } from "../../servicios/cat-reportes.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { ConfirmationService, MessageService } from "primeng/api";
import { exit } from "process";
import { AuxJasper, CatReportes, ImpuntDataRepote, ParametroJasper } from "../../entidades/entidades";
import { Router } from "@angular/router";

@Component({
  selector: 'app-cat-reportes',
  templateUrl: './cat-reportes.component.html',
  styleUrls: ['./cat-reportes.component.css']
})
export class CatReportesComponent implements OnInit {
  inputsForm: FormGroup;
  catReportes: CatReportes[] = [];
  impuntDataRepote: ImpuntDataRepote[];
  formGroupConfig: any = {};
  elementInpunts: any[] = [];
  auxJasper: AuxJasper = new AuxJasper();
  parametroJasper: ParametroJasper[] = [];
  reporte: CatReportes;
  nombreReporte: string;
  display: boolean = false;
  mostrarImpresora: boolean = false;
  public muestraMensaje = new MuestraMensaje();
  progressBar: boolean = false;
  public rutaLlamada: string = "";
  public sinParametros: boolean = false;
  archivoGeneradoSubject = new EventEmitter<void>();

  constructor(
    private formBuilder: FormBuilder,
    private catReportesService: CatReportesService,
    private messageService: MessageService,
    private router: Router,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.rutaLlamada = this.router.url; //Obtenemos la ruta de la página
    this.inputsForm = this.formBuilder.group({});
    switch (this.rutaLlamada) {
      case "/atencion/reporte-atencion":
        this.getByGrupoReporte(1);
        break;
      case "/liquidacion/reportes-facturacion-cobranza":
        this.getByGrupoReporte(2);
        break;
      default:
        this.getAllReportesJasper();
        break;
    }
  }
  
  async getAllReportesJasper() {
    try {
      this.catReportes = [];
      const datoRetorno = await this.catReportesService.getAll().toPromise();
      this.catReportes = datoRetorno;
      this.catReportes.unshift({ numRow: 0, baja: false, cambio: false, id: 0, etiqueta: 'SELECCIONA...', nombreJasper: 'SELECCIONA...', idEstatus: '', idGrupoReporte: 0, data: [] });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllReportesJasper");
    }
  }

  async getByGrupoReporte(idGrupoReporte: number) {
    try {
      this.catReportes = [];
      const datoRetorno = await this.catReportesService.getSingleByGrupo(idGrupoReporte).toPromise();
      this.catReportes = datoRetorno;
      this.catReportes.unshift({ numRow: 0, baja: false, cambio: false, id: 0, etiqueta: 'SELECCIONA...', nombreJasper: 'SELECCIONA...', idEstatus: '', idGrupoReporte: 0, data: [] });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    }
  }

  async limpiar() {
    this.inputsForm.reset();
    this.impuntDataRepote = [];
    this.formGroupConfig = [];
    this.elementInpunts = [];
    this.mostrarImpresora = false;
  }

  async buscarReporte(rep: CatReportes) 
  {
    try {
      await this.limpiar();
      
      if(rep == null){
        this.inputsForm = this.formBuilder.group({});
        exit;
      }
      this.mostrarImpresora = true;
      this.nombreReporte = rep.nombreJasper;
      const datoRetorno = await this.catReportesService.getSingle(rep.id).toPromise();
      this.sinParametros = datoRetorno.data == null ? true : false;
      
      if (datoRetorno && datoRetorno.data) {
        this.impuntDataRepote =  JSON.parse(datoRetorno.data.toString()) as ImpuntDataRepote[];
      }
      else{
        this.impuntDataRepote = [];
      }
      
      this.impuntDataRepote.forEach(element => {
        element["catalogo"] = {}
      });
      //establesemos grupo de formulario
      this.impuntDataRepote.forEach(element => {
        this.formGroupConfig[element.nombre] = [element.valor || undefined]; 
      });
      //adjuntamos los atributos que tendran noestro formulario para captura de parametros segun reporte
      this.inputsForm = this.formBuilder.group(this.formGroupConfig);
      this.impuntDataRepote.forEach(element => {
        this.elementInpunts.push(element) 
      });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por buscarReporte");
    }
  }

  async imprimeReporte(event) {
    try {
      this.progressBar = true;
      this.auxJasper = new AuxJasper();
      if (!this.validaParametros()){
        this.muestraMensaje.warning("Faltan datos necesarios para generar el reporte. Por favor, complete toda la información requerida antes de continuar.","top","center");
        return;
      }
  
      await this.obtieneParametros(event);

      if(event == "pdf"){
        this.display = true;
      }
      
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
      this.progressBar = false;
    }
  }

  validaParametros(): boolean{
    let resp = true
    let inputsform = this.inputsForm.value;
    if(this.sinParametros) return resp;
    Object.entries(inputsform).forEach(([key, value]) => {

      //podemos establecer un valor por defecto y calid
      if (value == null)
        {
          // podemos controlar si un input pude ir en null o vacio
          // if (key == "calcula_cargos" || key == "cuenta"){
          //   resp = true
          // }else{
            resp = false
          // };
        };  
    });
    return resp;
  };

  async obtieneParametros(event) {
    try {
      let inputsform = this.inputsForm.value;
      this.parametroJasper = [];
      this.auxJasper.JasperReport.nombreReporte = this.nombreReporte;
      this.auxJasper.JasperReport.tipo = event;
  
      // Recorremos los inputs del form para llenar los parámetros del Jasper report
      Object.entries(inputsform).forEach(([key, value]) => {
        let parametros = new ParametroJasper();
        parametros.nombre = key;
        if (value !== null && value !== undefined) {
          parametros.valor = value.toString();
        } else {
          parametros.valor = ''; // Asigna un valor por defecto (cadena vacía)
        }
        this.parametroJasper.push(parametros);
      });

      //Este es para limitar que mostrar en un mismo reporte pero de un formato .xlsx
      if(event == "xlsx"){
        let parametroFormat = new ParametroJasper();
        parametroFormat.nombre = "formato";
        parametroFormat.valor = "xlsx";
        this.parametroJasper.push(parametroFormat);
      }
      // Asignamos los parámetros al auxiliar
      this.auxJasper.ParametroJasper = this.parametroJasper;

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
      // Aquí puedes manejar el error de la manera que consideres
    }
  }
  progressBar2(event) {
    this.progressBar = false;
  }
}
